import React from 'react'
import './core2webRatingCard.css'

function C2wRatingCard() {
      return (
            <a
                  href="https://play.google.com/store/apps/details?id=com.developer.core2web2&pcampaignid=web_share"
                  target="_blank"
                  rel="noreferrer"
            >
                  <div className='C2wRatingCard_ctn'>
                        <img className='C2wRatingCard_c2w_logo' src='/assets/images/landing/c2wlogo.svg' />
                        <div className='C2wRatingCard_content_holder'>
                              <div className='C2wRatingCard_content_div'>
                                    <div className='ratingValueDiv'>
                                          {4.9}
                                          <img className='ratingStart' src='/assets/images/reviews/ratingStart.png' alt='ratingStart' />
                                    </div>
                                    <p>{'970+ reviews'}</p>
                              </div>
                              <div className='C2wRatingCard_content_div'>
                                    <div className='ratingValueDiv'>
                                          {'10K+'}
                                    </div>
                                    <p>{'Downloads'}</p>
                              </div>
                              <div style={{ borderRight: 'none' }} className='C2wRatingCard_content_div'>
                                    <div className='ratingValueDiv'>3+</div>
                                    <p>{'Rated for 3+'}</p>
                              </div>
                        </div>
                  </div>
            </a>
      )
}

export default C2wRatingCard
